import { Navigate, Route, Routes, useLocation } from "react-router";
import { NavItems } from "../../../common/helpers/navigation";
import AssessmentWelcome from "./assessmentWelcome";
import { AssessmentReview } from "./assessmentReview";
import { AssessmentChecks } from "./assessmentChecks";
import { ContactFacilitator } from "./contactFacilitator";
import { isRemoteAssessmentComplete } from "../helpers/remoteAssessmentCompletion";

export const AssessmentLanding = (): JSX.Element => {
    const location = useLocation();

    if (isRemoteAssessmentComplete(location.pathname)) {
        return <Navigate to={NavItems.Assessments.AssessmentComplete.path} replace />;
    }

    return (
        <Routes>
            <Route path="*" element={<AssessmentWelcome />} />
            <Route path={NavItems.Assessments.AssessmentChecks.relativePath} element={<AssessmentChecks />} />
            <Route path={NavItems.Assessments.ContactFacilitator.relativePath} element={<ContactFacilitator />} />
            <Route path={NavItems.Assessments.AssessmentReview.relativePath} element={<AssessmentReview />} />
        </Routes>
    );
};
